// import { AddressPost } from '../models/address-post';
// import { FriendStudentPost } from '../models/friend-student-post'

export class CreateLogin {

  constructor() {
    this.id = '';
    this.firstName = '';
    this.middleName = '';
    this.lastName = '';
    this.email = '';
    this.password = '';
    this.confirmpass = '';
    this.roleId = '1';
  }

  id: string;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  password: string;
  confirmpass: string;
  roleId: string;
}



// WEBPACK FOOTER //
// ./src/app/models/create-login.ts